import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { useSelector } from 'react-redux';
import pluralize from 'pluralize';

import { PhotoSearchUpsellCheckout } from '../../../../apps/temp/views/onboarding/PhotoSearchUpsell';
import { AlbumFolderWithIdentityAccess } from '../../../../graphql/queries/album-folder';
import useOpenAlert from '../../../../hooks/useOpenAlert';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const JoinAlbumFolderPhotoSearchCheckout = ({ albumFolder }) => {
  const history = useHistory();
  const { selectedIdentities } = useSelector(({ discoverAlbumFolder }) => ({
    selectedIdentities: discoverAlbumFolder.identities,
  }));
  const openAlert = useOpenAlert();

  const onCheckoutSuccess = () => {
    openAlert({
      type: 'success',
      title: 'Congrats!',
      message: `${pluralize(
        'face',
        selectedIdentities.length,
        true,
      )} has been joined to the event!`,
    });

    history.replace(
      `/app/shutterbug/hierarchy-items/${albumFolder.id}/matches`,
    );
  };

  return <PhotoSearchUpsellCheckout onSuccess={onCheckoutSuccess} />;
};

JoinAlbumFolderPhotoSearchCheckout.propTypes = propTypes;

const withAlbumFolder = graphql(AlbumFolderWithIdentityAccess, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
  }),
});

export default compose(
  withRouter,
  withAlbumFolder,
)(JoinAlbumFolderPhotoSearchCheckout);
